/* eslint-disable max-len */
const React = require('react');

const OnlinePaymentsCheckoutPro = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="38" height="40" viewBox="0 0 38 40">
    <g fill="none" fillRule="evenodd" stroke="#009EE3">
      <path strokeWidth="1.6" d="M.8 34.2h36.4V8A2.2 2.2 0 0 0 35 5.8H3A2.2 2.2 0 0 0 .8 8v26.2z" />
      <path strokeWidth="1.4" d="M0 11.5h37H0zM5 17.5h14H5zM5 21.5h14H5zM5 25.5h9-9z" />
      <path strokeWidth="1.6" d="M24 16h8v13h-8z" />
    </g>
  </svg>
);

module.exports = OnlinePaymentsCheckoutPro;
